/** Raw loyalty/display status values from the V2 search programContext */
export const LOYALTY_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    SUSPENDED: 'SUSPENDED'
} as const

export const LOYALTY_DISPLAY_STATUS = {
    EXPIRED: 'EXPIRED',
    EXPIRING_SOON: 'EXPIRING_SOON',
    TRACKER_EXPIRING_SOON: 'TRACKER_EXPIRING_SOON',
    ACTIVATING_SOON: 'ACTIVATING_SOON'
} as const

export const LOYALTY_CONSTRAINT_TYPE_COUNT = 'COUNT'
export const LOYALTY_ACQUISITION_SOURCE_NONE = 'none'
export const LOYALTY_DEFAULT_TIER_TARGET = 2

/** elite_status analytics values */
export const ELITE_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUSPENDED: 'suspended',
    EXPIRED: 'expired',
    EXPIRING_SOON: 'expiring_soon',
    ACTIVATING_SOON: 'activating_soon'
} as const

/** Search context analytics values */
export const ANALYTICS_NOT_AVAILABLE = 'N/A'

export const JOURNEY_TYPE = {
    ROUND_TRIP: 'round_trip',
    ONEWAY: 'oneway'
} as const

export const TRIP_TYPE = {
    INTERNATIONAL: 'international',
    DOMESTIC: 'domestic'
} as const

export const DX_TYPE = {
    INTERNATIONAL: 'intl',
    DOMESTIC: 'dom'
} as const

export const UTM_SOURCE_ORGANIC = 'organic'

export const SRP_PAGE_NAME = 'flights_srp'
export const ITINERARY_PAGE_NAME = 'flights_itinerary'

/** action_name values for a_ui_action loyalty widget clicks */
export const LOYALTY_ACTION_NAME = {
    LOGGED_OUT_WIDGET_CLICK: 'ct_loyalty_login_widget_click',
    LOGGED_IN_WIDGET_CLICK: 'ct_loyalty_widget_click',
    BENEFITS_VIEW_CLICK: 'ct_loyalty_bottomsheet_view_benefits_click',
    BENEFITS_DISMISS_CLICK: 'ct_loyalty_bottomsheet_dismiss_click',
    FARE_SELECTED: 'ct_loyalty_fare_selected',
    BENEFIT_DESELECT_CLICK: 'ct_loyalty_benefit_deselect_click',
    // loyalty login funnel (sheet misspells some as 'loayalty'; using correct 'loyalty')
    LOGIN_PHONE_ENTERED: 'ct_loyalty_login_phone_number_entered',
    LOGIN_GET_OTP_CLICKED: 'ct_loyalty_login_get_otp_clicked',
    LOGIN_OTP_SCREEN_OPENED: 'ct_loyalty_login_otp_screen_opened',
    LOGIN_OTP_ENTERED: 'ct_loyalty_login_otp_entered',
    LOGIN_PROMPT_DISMISSED: 'ct_loyalty_login_prompt_dismissed',
    LOGIN_SUCCESSFUL: 'ct_loyalty_login_successful'
} as const

/** Raven event names */
export const LOYALTY_RAVEN_EVENT = {
    WIDGET_IMPRESSION: 'a_ct_loyalty_widget_impression',
    BENEFITS_BOTTOMSHEET_LOAD: 'a_ct_loyalty_benefits_bottomsheet_load',
    LOGIN_BOTTOMSHEET_LOAD: 'a_ct_loyalty_login_bottomsheet_load',
    UI_ACTION: 'a_ui_action'
} as const
